export const EventDelete = {
  name: "delete",
  component: "DeletePanel",
  layout: "delete-base",
  mode: "visible",
  showOn: true,
};
